import { Navigate, useLocation, useOutletContext, useParams } from 'react-router-dom';
import { dataReferenceTarget, legacyComplianceTarget, legacyCustomerTarget, legacySectionTarget, legacySettingsTarget } from '../lib/legacy-routes.js';
import DataReference from './DataReference.jsx';

// Old URLs of the tabbed customer page and the old top navigation (portal
// workbench, 2026-09-29). Every one redirects with replace, keeping the
// customer, and applies the landing rule when the user cannot see the
// target (lib/legacy-routes.js). In-app links use the new routes directly.

/** /customers/:customerId, with or without the old tab parameter, and unknown sections. */
export function LegacyCustomerRedirect() {
  const { customerId } = useParams();
  const { search } = useLocation();
  const { navClaims } = useOutletContext();
  return <Navigate to={legacyCustomerTarget(navClaims, customerId, search)} replace />;
}

/** /customers/:customerId/activity and /collection: the renamed sections. */
export function LegacySectionRedirect() {
  const { customerId } = useParams();
  const { pathname } = useLocation();
  const { navClaims } = useOutletContext();
  const old = pathname.replace(/\/+$/, '').split('/').pop();
  return <Navigate to={legacySectionTarget(navClaims, customerId, old)} replace />;
}

/** /customers/:customerId/compliance: the section before the ENTRAID-341 rename, with its tab. */
export function LegacyComplianceRedirect() {
  const { customerId } = useParams();
  const { search } = useLocation();
  const { navClaims } = useOutletContext();
  return <Navigate to={legacyComplianceTarget(navClaims, customerId, search)} replace />;
}

/** /settings: Sources of the active customer (today's SettingsRedirect). */
export function LegacySettingsRedirect() {
  const { navClaims } = useOutletContext();
  return <Navigate to={legacySettingsTarget(navClaims)} replace />;
}

/** /data-reference: the generic catalog for operators, else the customer's own route. */
export function DataReferenceRoute() {
  const { search, hash } = useLocation();
  const { navClaims } = useOutletContext();
  const to = dataReferenceTarget(navClaims, search, hash);
  return to ? <Navigate to={to} replace /> : <DataReference />;
}
